import { Component, OnInit, Input } from '@angular/core';
import { CommonUtil } from '../Utils/common-util';

import {RootScopeDeclare} from '../rootscope-declare';
import {RootScopeService} from '../shared-service/root-scope.service';

interface IStatusData {
  connectedCount: string;
  idleCount: string;
  notConnectedCount: string;
  showIdle: boolean;
}

@Component({
  selector: 'app-status-legend',
  templateUrl: './status-legend.component.html',
  styleUrls: ['./status-legend.component.css']
})
export class StatusLegendComponent implements OnInit {
  statusLegendDisconnectedMsg:string;
  rootScopeData: RootScopeDeclare;
  @Input() statusData: IStatusData;
  constructor(public commonUtil:CommonUtil, private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  ngOnInit() {
    let troubleShootLink = ' <a class="troubleShootLink" target="_blank" href="https://halofitness.zendesk.com/hc/en-us/articles/360060364271-Connect-Equipment-to-Internet">' + this.commonUtil.translateText('TROUBLESHOOT') + '</a>.';
    this.statusLegendDisconnectedMsg = this.commonUtil.translateText('EQUIPMENT.NOT.CONNECTED') + troubleShootLink;
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

}
